import { ReactNode } from 'react';

import { Box, Text } from '@chakra-ui/react';
import { BoxProps } from '@chakra-ui/react';

import { Card } from '~/components/card';
import { Glyph } from '~/components/glyph';
import { Markdown } from '~/components/markdown';

export function EnterpriseResourceGlyphCard({
  title,
  glyphName,
  markdownContent,
  topSlot,
  ...boxProps
}: {
  title: string;
  glyphName: string;
  markdownContent: string;
  topSlot?: ReactNode;
} & BoxProps) {
  return (
    <Card padding='40px' {...boxProps}>
      <Glyph height={64} name={glyphName} width={64} />

      <Box height='40px' />

      {topSlot}

      {topSlot && <Box height='16px' />}

      <Text fontWeight='600' marginBottom='16px'>
        {title}
      </Text>

      <Markdown markdownText={markdownContent} />
    </Card>
  );
}
